import { useEffect } from 'react';
import type { WebserviceCharacteristic } from '../../schema';
import { useEvaluated } from '../../eval/EvalContext';
import { useTranslation } from '../../i18n';
import { formatCalculatedValue } from './formatCalculatedValue';

/**
 * Read-only display of a webservice-resolved value. URL + path + return
 * type are admin-side config — they never appear in the customer UI;
 * `console.debug` keeps them available to support without cluttering the
 * configurator.
 */
export function WebserviceView({ characteristic }: { characteristic: WebserviceCharacteristic }) {
    const { locale } = useTranslation();
    const result = useEvaluated(characteristic.id);

    useEffect(() => {
        console.debug(
            '[configento] webservice result',
            characteristic.altTitle || characteristic.id,
            {
                url: characteristic.webserviceUrl,
                path: characteristic.webservicePath,
                returnType: characteristic.webserviceReturnType,
                result,
            },
        );
    }, [
        characteristic.id,
        characteristic.altTitle,
        characteristic.webserviceUrl,
        characteristic.webservicePath,
        characteristic.webserviceReturnType,
        result,
    ]);

    return (
        <span className="cfg-calc-value" data-configento-eval-result>
            {formatCalculatedValue(result, characteristic.decimalPlace, locale)}
        </span>
    );
}
